{
  "LOGIN": {
    "TITLE": "Belépés a kontaktközpontba",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Kérjük helyes e-mailcímet adj meg"
    },
    "PASSWORD": {
      "LABEL": "Jelszó",
      "PLACEHOLDER": "Jelszó"
    },
    "API": {
      "SUCCESS_MESSAGE": "Bejelentkezés sikeres",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később",
      "UNAUTH": "A felhasználó / jelszó helytelen. Kérjük próbálja újra",
      "ACCOUNT_DEACTIVATED": "Fiókja deaktiválva lett. Kérjük, forduljon adminisztrátorához.",
      "PASSWORD_LOGIN_DISABLED": "A jelszavas bejelentkezés le van tiltva a fiókjához. Kérjük, jelentkezzen be OAuth-tal (pl. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Bejelentkezés Google-el",
      "BUSINESS_ACCOUNTS_ONLY": "Kérlek a céges email címed használd bejelentkezéshez",
      "NO_ACCOUNT_FOUND": "Nem található fiók az email címedhez."
    },
    "FORGOT_PASSWORD": "Elfelejtetted a jelszavad?",
    "CREATE_NEW_ACCOUNT": "Új fiók létrehozása",
    "SUBMIT": "Bejelentkezés"
  }
}
